<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Subscription Renewal
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>
            <p>
                Once you have the latest version of the software installed, follow these steps to renew the subscription and activate
                your license.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
            </ul>

            <p class='text-red'>
                If your Subscription has been lapsed for more than 3 months, the renewal process will first reinstate it and then
                add a new 12-month term (starting from the renewal date). The cost for reinstatement is 75% of the Subscription
                fees for the first 12-months lapsed, and 50% of the fees for the remainder of the lapsed period. (Subject to
                change without prior notice.)
            </p>

            <ol class='help-listStyle q-mt-lg'>
                <li>
                    Run the program
                    <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Click the '<span class='text-weight-medium'>Purchase or Renew License</span>' option. This will take you to the activation website.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/PurchaseOrRenewLink.jpg')" />
                </li>
                <li>
                    The website will now open with the option '<span class='text-weight-medium'>Renew my annual subscription</span>' selected. Click <span class='text-weight-medium'>Continue</span> to proceed.
                </li>
                <li>
                    Login to your account. If you do not recall your password, use the '<span class='text-weight-medium'>Forgot Password?</span>' link to reset it.
                </li>
                <li>
                    <p>When you get to the shopping cart page, if you have a Prepaid Code or Discount Code enter it here.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/DiscountCode_Renew_Website.jpg')" />
                </li>
                <li>
                    Click <span class='text-weight-medium'>Continue</span> to proceed with the checkout process.
                </li>
                <li>
                    <p>When completed, the Activation Code will be displayed on screen and will also be sent to you by email.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/ActivationCodeField.jpg')" /></p>
                    <p>For help on entering your new activation code, see the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> help topic.</p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'renew',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year
            }
        }
    }
</script>
